import React, { useMemo, useRef } from 'react';
import DefaultImg from '../../../assets/images/userdefault.png';
import '../core/filters.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
    addMightyFitFilter,
    removeMightyFitFilter,
    selectMightyFitFilters,
    selectMightyFitFiltersLoaded,
    selectMightyFitFiltersLoading,
    selectSelectedFilters,
} from '../core/filterSlice';
import { Form, Image, Spinner } from 'react-bootstrap';

export default function TrainersFilter() {
    const dispatch = useDispatch();
    const mightyFitFilters = useSelector(selectMightyFitFilters);
    const mightyFitFiltersLoading = useSelector(selectMightyFitFiltersLoading);
    const mightyFitFiltersLoaded = useSelector(selectMightyFitFiltersLoaded);
    const selectedFilters = useSelector(selectSelectedFilters);
    const trainers = useMemo(() => {
        return Array.isArray(mightyFitFilters.trainers)
            ? [...mightyFitFilters.trainers].sort((a, b) => b.count - a.count)
            : [];
    }, [mightyFitFilters.trainers]);
    const hasInteractedRef = useRef(false);

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const id = Number(event.target.value);
        const isChecked = event.target.checked;

        hasInteractedRef.current = true;

        if (isChecked) {
            dispatch(addMightyFitFilter(id));
        } else {
            dispatch(removeMightyFitFilter(id));
        }
    };

    return (
        <div className="scrollbar-new" id="style-3">
            <div className="wraptrainers">
                {(!mightyFitFiltersLoaded && mightyFitFiltersLoading) ?
                    <div className='text-center mt-5 w-100'>
                        <Spinner className="text-center text-dark" variant="primary" animation="grow" />
                    </div> : (trainers.length <= 0) ? (
                        <div className="text-center mt-5 w-100 text-muted">
                            No trainers found
                        </div>
                    ) : (
                        trainers.map((trainee: any, index: number) => {
                            const isChecked = selectedFilters.includes(Number(trainee.id));

                            return (
                                <div className="wt-box" key={index}>
                                    <div className="wt-left">
                                        <Image
                                            loading="lazy"
                                            src={trainee.trainer_image || DefaultImg}
                                            alt={trainee.trainer_name}
                                            className={trainee.trainer_image ? 'trainersImg' : 'defaultImg'}
                                        />
                                        <span>{trainee.trainer_name}</span>
                                    </div>
                                    <div className="wt-right">
                                        <Form.Check
                                            type="checkbox"
                                            className="tag-sbmt"
                                            name="tag[]"
                                            value={trainee.id}
                                            label={trainee.count}
                                            id={`trainer-${trainee.id}`}
                                            onChange={handleCheckboxChange}
                                            checked={isChecked}
                                        />
                                    </div>
                                </div>
                            );
                        })
                    )}
            </div>
        </div>
    );
}